import superAgentAvatar from '@/assets/super-agent-avatar.png'

/** Bundled avatar image for the Moly Super Agent (AI) member. */
export { superAgentAvatar }

/**
 * Resolve the avatar image source for a member. The Super Agent (AI) member
 * always uses the bundled Moly Super Agent avatar; everyone else uses their
 * uploaded profile picture (or none, so the initials fallback shows).
 */
export function memberAvatarSrc(
  member?: {
    isSuperAgent?: boolean | null
    profilePictureUrl?: string | null
  } | null,
): string | undefined {
  if (!member) return undefined
  if (member.isSuperAgent) return superAgentAvatar
  return member.profilePictureUrl ?? undefined
}
